/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type ListItem_item$ref: FragmentReference;
declare export opaque type ListItem_item$fragmentType: ListItem_item$ref;
export type ListItem_item = {|
  +id: string,
  +name: string,
  +region: ?string,
  +marketerEmails: ?string,
  +approvalRequired: ?boolean,
  +$refType: ListItem_item$ref,
|};
export type ListItem_item$data = ListItem_item;
export type ListItem_item$key = {
  +$data?: ListItem_item$data,
  +$fragmentRefs: ListItem_item$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ListItem_item",
  "type": "PicklistInterface",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "region",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "marketerEmails",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "approvalRequired",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd09622621620d24a56691380dfda5ed8';
module.exports = node;
